// common/hooks/useFiles.ts
import { useState } from 'react'
import { PairInterface } from '../types/interfaces'
import { v4 } from 'uuid'
import { getSalesApi } from '../../salesApi/salesApi'

export const useFiles = () => {
  const [files, setFiles] = useState<File[]>([])
  const [pairs, setPairs] = useState<PairInterface[]>([])
  let dataTransfer = new DataTransfer()
  const salesApi = getSalesApi()

  const dataInit = (files: File[]) => {
    dataTransfer = new DataTransfer()
    files.forEach((file: File) => {
      dataTransfer.items.add(file)
    })
    return dataTransfer.files
  }

  // Генерация постера из видео на клиенте
  const generatePoster = async (videoFile: File): Promise<File | null> => {
    return new Promise((resolve) => {
      const video = document.createElement('video')
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')

      video.src = URL.createObjectURL(videoFile)
      video.currentTime = 0.5
      video.muted = true

      video.onloadeddata = () => {
        canvas.width = video.videoWidth
        canvas.height = video.videoHeight
        ctx?.drawImage(video, 0, 0, canvas.width, canvas.height)
        canvas.toBlob(
          (blob) => {
            if (blob) {
              const posterFile = new File([blob], `poster_${Date.now()}.webp`, {
                type: 'image/webp',
              })
              resolve(posterFile)
            } else {
              resolve(null)
            }
          },
          'image/webp',
          0.8,
        )
      }

      video.onerror = () => {
        resolve(null)
      }
    })
  }

  const fetchFiles = async (filesToFetch: string[]) => {
    try {
      let videoFile: File | null = null
      let hasPoster = false

      for (const filePath of filesToFetch) {
        // Проверяем наличие постера
        if (filePath.includes('poster_')) {
          hasPoster = true
          continue
        }

        const result = await salesApi.download({ path: filePath })

        if (!result) {
          console.warn('⚠️ Нет данных для файла:', filePath)
          continue
        }

        const fileName = filePath.split('/').pop() || v4()
        const file = new File([result], fileName, {
          type: result.type || 'application/octet-stream',
        })

        setFiles((prev) => [...prev, file])
        setPairs((prev) => [
          ...prev,
          {
            file,
            url: URL.createObjectURL(file),
            type: filePath.includes('video_') ? 'video' : 'image',
          },
        ])

        // Запоминаем видео для генерации постера
        if (filePath.includes('video_')) {
          videoFile = file
        }
      }

      // Если есть видео, но нет постера — генерируем постер
      if (videoFile && !hasPoster) {
        console.log('🎬 Генерируем постер для видео при редактировании...')
        const poster = await generatePoster(videoFile)
        if (poster) {
          setFiles((prev) => [...prev, poster])
          // постер не добавляем в pairs, чтобы не показывать
          console.log('✅ Постер сгенерирован и добавлен в files')
        } else {
          console.log('❌ Не удалось сгенерировать постер')
        }
      }
    } catch (error) {
      console.error('❌ Error fetching files:', error)
    }
  }

  return {
    files,
    setFiles,
    pairs,
    setPairs,
    dataInit,
    fetchFiles,
  }
}
